// extracted by mini-css-extract-plugin
export default {"customPrimaryColor":"#ff7b00","customTextColor":"#ff7b00","customUserCardBorderColor":"#ff7b00"};